import { type BatchesState } from "./state";

export const initialState: BatchesState = {
  list: [],
  inventory: [],
  movementsSummary: null,
  holdings: [],
  receptions: [],
  portfolios: [],
  isPending: false,
  isRejected: false,
  errorMessage: "",
  isMutating: false,
  mutateError: "",
};
